import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Location } from "@angular/common";
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { BaseGuard } from "./base.guard.service";
import { Observable, concatMap, of } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class RoleGuardService extends BaseGuard {
  constructor(
    protected authService: MsalService,
    @Inject(MSAL_GUARD_CONFIG)
    protected override msalGuardConfig: MsalGuardConfiguration,
    protected override msalBroadcastService: MsalBroadcastService,
    protected override location: Location,
    protected router: Router
  ) {
    super(msalGuardConfig, msalBroadcastService, authService, location, router);
  }

  override activateHelper(state?: RouterStateSnapshot, route?: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const result = super.activateHelper(state);
    return result.pipe(
      concatMap(() => {
        const expectedRoles: string[] = route ? route.data["expectedRoles"] : [];
        let account = this.authService.instance.getActiveAccount();

        if (!account && this.authService.instance.getAllAccounts().length > 0) {
          account = this.authService.instance.getAllAccounts()[0];
        }

        if (account == null) return of(false);

        if (!account.idTokenClaims?.roles) {
          this.router.navigate(["unauthorize"]);
          return of(false);
        } else {
          const hasRequiredRole = expectedRoles.some((role: string) => account?.idTokenClaims?.roles?.includes(role));

          if (!hasRequiredRole) this.router.navigate(["unauthorize"]);
          return of(hasRequiredRole);
        }
      })
    );
  }
}
